import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BASE_URL, BaseApi, COMMON_URL } from "@edl-development/edl-common";
import { Observable, map } from 'rxjs';
import { OnboardingTemplateType } from "src/app/model/enum/onboarding-template-type.enum";

@Injectable()
export class OnboardingApi extends BaseApi {


    constructor(
        @Inject(BASE_URL) private baseUri: string,
        @Inject(COMMON_URL) private commonUrl: string,
        private http: HttpClient
    ) {
        super();
    }

    getTemplate(type: OnboardingTemplateType = OnboardingTemplateType.Onboarding) {
        // OnboardingTemplateType is a numeric enum, so `type` is just a number at runtime and
        // `type.toString()` would send its integer value ("0"/"1"), not its name. ASP.NET Web API's
        // enum model binder accepts either form, but sending the name keeps the request
        // self-documenting (?type=Existing rather than ?type=1).
        return this.http
            .get(this.commonUrl + '/onboarding/template', {
                params: new HttpParams().set('type', OnboardingTemplateType[type]),
                responseType: 'blob',
            });
    }


    onboardUsers(fileList: FileList) {
        let file: File = fileList[0];
        let formData: FormData = new FormData();
        formData.append('file', file, file.name);
        return this.http.post(this.commonUrl + '/onboarding/onboard', formData);
    }


}
